module.exports = __webpack_public_path__ + "static/media/qlh.4b12e412.jpg";